import { render, staticRenderFns } from "./addUser.vue?vue&type=template&id=687b831c&"
import script from "./addUser.js?vue&type=script&lang=js&"
export * from "./addUser.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports